<template>
  <q-dialog v-model="dialog" persistent>
    <q-card style="width: 700px; max-width: 80vw;">
      <q-card-section class="row items-center q-pa-sm bg-primary text-white">
        <div class="text-h6">Respostas do usuário</div>
        <q-space />
        <q-btn icon="close" flat round dense @click="dialog = false" />
      </q-card-section>
      <q-card-section>
        <div class="text-h6">
          Usuario: {{usuario.nome}}
        </div>
        <div class="">
          CPF: {{usuario.cpf}}
        </div>
      </q-card-section>
      <q-card-section class="q-pa-none no-shadow">
        <div class="col-12">
          <q-linear-progress color="primary" indeterminate v-if="loading" />
          <q-list separator bordered>
            <q-item v-for="(resposta, idx) of resultados" :key="idx">
              <q-item-section>
                <q-item-label><strong>{{resposta.pergunta}}</strong></q-item-label>
                <q-item-label
                  v-for="(resposta, idx) of resposta.respostas"
                  :key="idx"
                  class="q-pl-sm"
                >
                  {{resposta}}
                </q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { getRespostasDoUsuario } from '../../services/pesquisa'

export default {
  props: {
    idPesquisa: {
      type: String,
      required: true
    },
    usuario: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      resultados: [],
      dialog: false
    }
  },

  methods: {
    open () {
      this.getRespostasDoUsuario()
      this.dialog = true
    },

    async getRespostasDoUsuario () {
      try {
        this.loading = true
        this.resultados = await getRespostasDoUsuario({ idPesquisa: this.idPesquisa, cpfUsuario: this.usuario.cpf })
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'red',
          position: 'top-right',
          icon: 'report_problem',
          message: 'Não foi possível buscar as respostas no momento. Tente daqui a pouco.'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>